import MaorPledge from "./MaorPledge";

export default MaorPledge